<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Beranda Operator Dukcapil</h1>
        </div>

        <div class="section-body">
          <div
            v-if="showHero"
            class="hero bg-primary text-white mb-3"
          >
            <div class="hero-inner">
              <h2>Selamat Datang, {{ (profile) ? profile.nama_lengkap : '' }}!</h2>
              <p class="lead">
                <span class="font-weight-bold">SiPeDuLi Jembrana</span> atau Sistem Pelayanan Administrasi Kependudukan Online Masyarakat Jembrana merupakan
                aplikasi pelayanan publik Kabupaten Jembrana yang dapat digunakan oleh masyarakat untuk membuat dan memperbaiki
                berkas kependudukan dan pencatatan sipil.
              </p>
            </div>
            <button
              class="btn"
              style="position:absolute; right:20px; top: 20px"
              @click="showHero = false"
            >
              <i class="fa fa-times" />
            </button>
          </div>

          <DashboardHome />
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from './../layouts/Admin.vue'
import DashboardHome from './DashboardHome.vue'

export default {
	name: 'App',
	data(){
		return {
			showHero: true,
		}
	},
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		}
	},
	components: {
		LayoutAdmin, DashboardHome
	}
}
</script>

<style>

</style>
